import {IAuthClient} from "../../data/protocols/auth-client";
import { IHttpClient, THttpRequest, THttpResponse } from "../../data/protocols/http";

export class AuthorizeHttpClientDecorator implements IHttpClient {
  constructor(
    private readonly httpClient: IHttpClient,
    private readonly authClient: IAuthClient
  ) {}

  async request(data: THttpRequest): Promise<THttpResponse> {
    const token = await this.authClient.getToken();

    if (token) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: `Bearer ${token}`,
        }),
      });
    }

    return this.httpClient.request(data);
  }
}
